<template>
  <div>

    <div  class="form-group">
      <label for="form-mkt-prop-scheduled-types">{{ $t('Deferred send type') }}</label>
      <select id="form-mkt-prop-scheduled-types"
              class="form-control form-control-lg"
              name="send_parameters[type]"
              :value="modelValue.type"
              @change="update('type', $event.target.value)"
              required>
        <option value=""></option>
        <option v-for="e in scheduledTypes" :value="e.value">{{ e.name }}</option>
      </select>
    </div>

    <div class="form-group">
      <label for="form-mkt-prop-scheduled-date-start">{{ $t('Sending date') }}</label>
      <Datetime :modelValue="send_on"
                @update:modelValue="update('send_on', $event); min_send_until = $event"
                :disabled="!modelValue.type"
                :timezone="timezone"
                with-timezone
                type="datetime"
                :minute-step="5"
                :min-datetime="new Date().toISOString()"
                id="form-mkt-prop-scheduled-date-start"
                class="input-group-lg"
      ></Datetime>
      <input type="hidden" name="send_parameters[send_on]" :value="send_on">
    </div>

    <div class="form-group" v-if="modelValue.type === 'deferredWithRepetition'">
      <label for="form-mkt-prop-scheduled-date-end">{{ $t('Stop sending after') }}</label>
      <Datetime :modelValue="send_until"
                @update:modelValue="update('send_until', $event)"
                :disabled="!modelValue.send_on"
                :timezone="timezone"
                with-timezone
                :required="modelValue.type === 'deferredWithRepetition'"
                type="datetime"
                :minute-step="1"
                :min-datetime="min_send_until"
                id="form-mkt-prop-scheduled-date-end"
                class="input-group-lg"
      ></Datetime>
      <input type="hidden" name="send_parameters[send_until]" :value="send_until">
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Datetime from "@/components/ui/Datetime.vue";

export default {
  components: { Datetime },
  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {
          type: null,
          send_on: null,
          send_until: null,
        };
      },
    },
    scheduledTypes: {
      type: Array,
      default: function () {
        return [
        ];
      },
    },
    timezone: {
      type: String,
      default: 'UTC',
    },
  },
  data() {
    return {
      min_send_until: null,
      send_on: this.modelValue.send_on ? dayjs.utc(this.modelValue.send_on) : null,
      send_until: this.modelValue.send_until ? dayjs.utc(this.modelValue.send_until) : null,
    };
  },
  watch: {
    modelValue: {
      handler: function (value) {
        this.send_on = value.send_on ? dayjs.utc(value.send_on) : null;
        this.send_until = value.send_until ? dayjs.utc(value.send_until) : null;
      },
      deep: true,
    },
  },
  methods: {
    update: function (key, value) {
      this.$emit('update:modelValue',
        {
          ...this.modelValue,
          [key]: value,
        }
      );
    },
  },
}
</script>

<style scoped>

</style>